import React from 'react';

import { EngagementsTabNavigation } from '../components/EngagementsTabNavigation/EngagementsTabNavigation';
import { EngagementsHistoryView } from '../components/EngagementsHistoryView/EngagementsHistoryView';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type TalentEngagementsHistoryPageProps = {
  name?: string;
};

export const TalentEngagementsHistoryPage = ({
  name = 'TALENT_ENGAGEMENTS_HISTORY_PAGE',
}: TalentEngagementsHistoryPageProps) => {
  useDocumentTitle('Engagements');
  return (
    <div data-test={name}>
      <EngagementsTabNavigation pathToEngagements=".." startTab="HISTORY_TAB" />
      <EngagementsHistoryView />
    </div>
  );
};
